const IS_APPROVING_SHIFTS = 'IS_APPROVING_SHIFTS';
const APPROVE_SHIFTS_SUCCESS = 'APPROVE_SHIFTS_SUCCESS';
const APPROVE_SHIFTS_ERROR = 'APPROVE_SHIFTS_ERROR';
const CLEAR_APPROVE_SHIFTS_ERROR = 'CLEAR_APPROVE_SHIFTS_ERROR';
const VALIDATION_ERROR = 'VALIDATION_ERROR';

export const isApprovingShifts = () => ({ type: IS_APPROVING_SHIFTS });
export const approveShiftsSuccess = () => ({ type: APPROVE_SHIFTS_SUCCESS });
export const approveShiftsError = (error) => ({ type: APPROVE_SHIFTS_ERROR, error });
export const clearApproveShiftsError = () => ({ type: CLEAR_APPROVE_SHIFTS_ERROR });
export const validationError = (error) => ({ type: VALIDATION_ERROR, error });

const initialState = {
  isApprovingShifts: false,
  approveShiftsError: null,
  validationError: null,
};

function approveShiftsReducer(prevState = initialState, action) {
  switch (action.type) {
    case IS_APPROVING_SHIFTS: return { ...prevState, isApprovingShifts: true, approveShiftsError: null, validationError: null };
    case APPROVE_SHIFTS_SUCCESS: return { ...prevState, isApprovingShifts: false };
    case APPROVE_SHIFTS_ERROR: return { ...prevState, isApprovingShifts: false, approveShiftsError: action.error };
    case CLEAR_APPROVE_SHIFTS_ERROR: return { ...prevState, isApprovingShifts: false, approveShiftsError: null, validationError: null };
    case VALIDATION_ERROR: return { ...prevState, isApprovingShifts: false, validationError: action.error };
    default:
      return prevState;
  }
}

export default approveShiftsReducer;


